import type { FC } from "react";
import type { InputProps } from "../../DynamicInput";
import { SystemInput } from "../../shared/SystemInput";

export const System: FC<InputProps<string[]>> = props => <SystemInput {...props} />;
